import React from 'react';
import {
  FIRST_NAME_MAX_LENGTH,
  LAST_NAME_MAX_LENGTH,
  useLoginAdminAccount,
} from './useLoginAdminAccount';
import { FormProvider } from 'react-hook-form';
import { FormInput } from 'components/stepper/field-components';
import FormPassInput from 'components/stepper/field-components/FormPassInput';
import ButtonComponent from 'components/button/buttonComponent';
import { useValidateSignupToken } from './useValidateSignupToken';

const NewAdminSetup = () => {
  useValidateSignupToken();
  const { methods, onSubmit, loading } = useLoginAdminAccount();

  return (
    <div
      data-testid="setup-admin"
      className="flex flex-wrap mt-16 desktop:px-24 overflow-hidden w-[692px] desktop:mb-0 desktop:p-0 desktop:max-w-screen-xl desktop:mx-auto"
    >
      <div className="flex flex-col border gap-1 w-full h-full p-30 bg-white rounded-10 border-gray-opacity-15">
        <h3 className="font-semibold text-h3 desktop:text-h3 text-neutral-800">
          {'Welcome, new admin!'}
        </h3>
        <p className="font-medium text-med-gray-3">
          Please enter your first and last name and set password for your
          admin’s DECODE.ME™ account
        </p>

        <FormProvider {...methods}>
          <form
            onSubmit={onSubmit}
            className="mt-4 flex flex-col gap-5"
            noValidate
            autoComplete="off"
          >
            <div className="flex flex-col gap-2.5">
              <FormInput
                name="firstName"
                maxLength={FIRST_NAME_MAX_LENGTH}
                label="First name"
              />
              <FormInput
                name="lastName"
                maxLength={LAST_NAME_MAX_LENGTH}
                label="Last name"
              />
            </div>

            <div className="flex flex-col gap-2.5">
              <FormPassInput
                name="password"
                label="Password"
                describe="Password must contain at least 1 capital letter, 1 lowercase letter, 1 number, 1 special character, and be between 8-64 characters long"
              />
              <FormPassInput name="confirmPassword" label="Confirm password" />
            </div>

            <ButtonComponent
              className="w-full"
              type="submit"
              testID="setup-admin"
              disabled={loading}
              showSpinner={loading}
            >
              Set password
            </ButtonComponent>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default NewAdminSetup;
